import React, { Fragment, useEffect, useState } from "react";
import { CCollapse, CLink } from "@coreui/react";
import { Formik, Form, Field } from "formik";
import config from "../../config/config";
import axios from "axios";

import { toastError, toastSuccess } from "../../common/Toast";
import {
  SUCCESS_MESSAGE,
  ERROR_MESSAGE,
  AWS_IMAGE_FOLDER_STORECONFIG,
} from "../../common/Constant";
import Loader from "../Loader/Loader";
import { uploadAWS } from "../../common/AWSHelper";
import FileInput from "../FormControls/FileInput";
import { Noimage } from "../../common/imagePath";

const CompanyInformation = (props) => {
  console.log(props);
  const [visibleCompanyInformation, setVisibleCompanyInformation] =
    useState(false);
  const [comingInformation, setcomingInformation] = useState(
    props.visibleInformationChange
  );
  const [formValues, setFormValues] = useState({
    CompanyLogo: "",
    DeleteLogo: false,
    CompanyName: "",
    TaxID: "",
    Website: "",
  });
  const [loading, setLoading] = useState(false);
  const [changeImagename, setChangeImagename] = useState(false);
  const [ImageUrl, setImageUrl] = useState("");
  const [imageHeaderUrl, setImageHeaderUrl] = useState("");
  const [imageFaviconUrl, setImageFaviconUrl] = useState("");
  const [selectedLogo, setSelectedLogo] = useState("");
  const [btnLoader, setBtnLoader] = useState({ CompanyLogo: false });

  const token = localStorage.getItem("Token");

  const _handleFileChange = (e) => {
    setChangeImagename(true);
    if (vaidation(e.target.name, e?.currentTarget?.files[0])) {
      uploadFile(e?.currentTarget?.files[0], e.target.name);
    }
  };


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;
console.log(name, value, "handelchange")
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: fieldValue,
    }));
  };

  const vaidation = (name, value) => {
    switch (name) {
      case "CompanyLogo":
        if (!value.name.match(/\.(jpg|jpeg|png|gif)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };

  const uploadFile = async (file, type) => {
    setBtnLoader({ [type]: true });
    await uploadAWS(file, AWS_IMAGE_FOLDER_STORECONFIG, (data) => {
      if (data) {
        if (type === "CompanyLogo") setImageUrl(data);
        if (type === "CompanyHeaderLogo") setImageHeaderUrl(data);
        if (type === "favicon") setImageFaviconUrl(data);
      }
    });
  };

  const handleSubmit = (values) => {
    const formArray = [
      { AppConfigkey: "CompanyLogo", AppConfigvalue: ImageUrl },
      { AppConfigkey: "CompanyHeaderLogo", AppConfigvalue: imageHeaderUrl },
      { AppConfigkey: "favicon", AppConfigvalue: imageFaviconUrl },
      { AppConfigkey: "DeleteLogo", AppConfigvalue: values.DeleteLogo },
      { AppConfigkey: "CompanyName", AppConfigvalue: values.CompanyName },
      { AppConfigkey: "TaxID", AppConfigvalue: values.TaxID },
      { AppConfigkey: "Website", AppConfigvalue: values.Website },
      { AppConfigkey: "CompanyAddress", AppConfigvalue: values.CompanyAddress}
    ];

    const jsonobj = {};
    jsonobj.StoreConfig = formArray;

    let jsonstring = JSON.stringify(jsonobj);

    setLoading(true);

    axios
      .post(
        `${config.storeConfigBaseUrl}/storeconfig/upsert`,
        {
          type: "COMPANY_INFORMATION",
          storeconfigxml: jsonstring,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
        } else {
          toastError(ERROR_MESSAGE);
        }

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

    const handleCompany=()=>{
    setLoading(true);
    axios
      .get(
        `${config.storeConfigBaseUrl}/storeconfig/getallconfig?type=COMPANY_INFORMATION`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        const responseData = response.data.ResponseData;

        responseData.map((data) => {
          if (data.AppConfigkey === "CompanyLogo") {
            setImageUrl(data.AppConfigvalue);
          } else if (data.AppConfigkey === "CompanyHeaderLogo") {
            setImageHeaderUrl(data.AppConfigvalue);
          } else if (data.AppConfigkey === "favicon") {
            setImageFaviconUrl(data.AppConfigvalue);
          } else if (data.AppConfigkey === "DeleteLogo") {
            formValues.DeleteLogo =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "CompanyName") {
            formValues.CompanyName = data.AppConfigvalue;
          } else if (data.AppConfigkey === "TaxID") {
            formValues.TaxID = data.AppConfigvalue;
          } else if (data.AppConfigkey === "Website") {
            formValues.Website = data.AppConfigvalue;
          }else if(data.AppConfigkey==="CompanyAddress"){
            formValues.CompanyAddress= data.AppConfigvalue;
          }
        });

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
    }

  const data = [
    {
      name: "Company Logo",
      input: (
        <>
          <div className="col-md-10">
            <FileInput
              className="form-control form-control-sm"
              id="CompanyLogo"
              name="CompanyLogo"
              value={selectedLogo}
              accept="image/*"
              handleChange={_handleFileChange}
            />
          </div>
          <div className="row">
            <div
              className={`${
                ImageUrl ? "" : selectedLogo ? "" : "d-none"
              } form-group row`}
            >
              <label className="col-form-label col-md-2 control-label"></label>
              <div className="col-md-10">
                <img
                  src={`${ImageUrl ? ImageUrl : selectedLogo}`}
                  alt="Category Image"
                  className="ImagePreviewSize"
                />
              </div>
            </div>
          </div>
         
            <div className="col-md-10">
              <span className="text-danger">Maintain this Image size ratio : 145px x 50px and Below 150KB.</span>
            </div>
          
        </>
      ),
    },
    {
      name: "Company Header Logo",
      input: (
        <>
          <div className="col-md-10">
            <FileInput
             className="form-control form-control-sm"
              id="CompanyHeaderLogo"
              name="CompanyHeaderLogo"
              accept="image/*"
              handleChange={_handleFileChange}
            />
          </div>
          <div className="row">
            <div
              className={`${
                imageHeaderUrl ? "" : "d-none"
              } form-group row`}
            >
              <label className="col-form-label col-md-2 control-label"></label>
              <div className="col-md-10">
                <img
                  src={`${imageHeaderUrl ? imageHeaderUrl : Noimage}`}
                  alt="Category Image"
                  className="ImagePreviewSize"
                />
              </div>
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Favicon",
      input: (
        <>
          <div className="col-md-10">
            <FileInput
             className="form-control form-control-sm"
              id="favicon"
              name="favicon"
              // value={selectedLogo}
              accept="image/*"
              handleChange={_handleFileChange}
            />
          </div>
          <div className="row">
            <div
              className={`${
                imageFaviconUrl ? "" : "d-none"
              } form-group row`}
            >
              <label className="col-form-label col-md-2 control-label"></label>
              <div className="col-md-10">
                <img
                  src={`${imageFaviconUrl ? imageFaviconUrl : Noimage}`}
                  alt="Category Image"
                  className="ImagePreviewSize"
                />
              </div>
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Company Name:",
      input: (
        <>
          <div className="input-group">
            <Field
              type="text"
              className="form-control form-control-sm"
              id="CompanyName"
              name="CompanyName"
              onChange={(e)=> handleChange(e)}
            />
          </div>
        </>
      ),
    },
    {
      name: "Tax ID:",
      input: (
        <>
          <div className="input-group">
            <Field
              type="text"
              className="form-control form-control-sm"
              id="TaxID"
              name="TaxID"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Website:",
      input: (
        <>
          <div className="input-group">
            <Field
              type="text"
              className="form-control form-control-sm"
              id="Website"
              name="Website"
              onChange={handleChange}
            />
          </div>
        </>
      ),
    },
    {
      name: "Company Address:",
      input: (
        <>
          <div className="input-group">
            <Field
              type="text"
              as="textarea"
              className="form-control form-control-sm"
              id="CompanyAddress"
              name="CompanyAddress"
              onChange={handleChange}
              style={{
                width: '100%', // set width to 100% of parent container
                height: 'auto', // set height to auto, so it adjusts to content
                resize: 'vertical' // allow vertical resizing
              }}
            />
          </div>
        </>
      ),
    }   
  ];

  const matchesSearchQuery = data.filter((el) => {
    return el.name.toLowerCase().includes(props.searchQuery.toLowerCase());
  });

  return (
    <>
      <Fragment>
        {
          matchesSearchQuery.length === data.length?(
            <div className="card">
            <div  style={{padding :"0px"  , marginTop:"16px" , marginLeft: "18px"}}  className="card-header">
              <h5 className="card-title">
                <CLink
                style={{color:"var(--primary-main-color)"}}
                  className="accordion-header"
                  onClick={() => {
                    handleCompany()
                    setVisibleCompanyInformation(!visibleCompanyInformation);
                    setcomingInformation(!!comingInformation);
                  }}
                >
                  Company Information
                </CLink>
              </h5>
            </div>
            <CCollapse
              visible={
                visibleCompanyInformation || props.visibleInformationChange
              }
            >
              <div className="card-body">
                <Formik
                  {...props}
                  initialValues={formValues}
                  onSubmit={handleSubmit}
                  enableReinitialize
                >
                  {() => (
                    <Form>
                      <div className="row">
                      <div
                      style={{
                        display: "flex",
                        width: "50%",
                        flexDirection: "column",
                        alignItems: "flex-start"
                      }}
                    >
                      {matchesSearchQuery &&
                        matchesSearchQuery?.map((el) => (
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "space-between"
                            }}
                          >
                            <label
                              className="col-form-label"
                              style={{ fontSize: "15px" }}
                            >
                              {el.name}
                            </label>
                            <div 
                            style={{
                              width:"53%"
                            }}
                            >{el.input}</div>
                          </div>
                        ))}
                    </div>
                      </div>
                      <button
                        type="submit"
                        className="btn btn-sm btn-primary pull-right mb-3"
                      >
                        Save
                      </button>
                    </Form>
                  )}
                </Formik>
              </div>
            </CCollapse>
          </div>
          ):(
            matchesSearchQuery.length!==0 &&
            <div  className="card">
            <div  className="card-header">
              <h5  className="card-title">
                <CLink
                  className="accordion-header"
                  onClick={() => {
                    setVisibleCompanyInformation(!visibleCompanyInformation);
                    setcomingInformation(!!comingInformation);
                  }}
                >
                  Company Information
                </CLink>
              </h5>
            </div>
            <CCollapse
              visible={
                visibleCompanyInformation || props.visibleInformationChange
              }
            >
              <div className="card-body">
                <Formik
                  {...props}
                  initialValues={formValues}
                  onSubmit={handleSubmit}
                  enableReinitialize
                >
                  {() => (
                    <Form>
                      <div className="form-group row">
                      <div
                      className="col-md-6"
                    >
                      {matchesSearchQuery &&
                        matchesSearchQuery?.map((el) => (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-evenly",
                            }}
                          >
                            <label
                              className="col-form-label"
                              style={{ fontSize: "15px" }}
                            >
                              {el.name}
                            </label>
                            <div>{el.input}</div>
                          </div>
                        ))}
                    </div>
                      </div>
                      <button
                        type="submit"
                        className="btn btn-sm btn-primary pull-right mb-3"
                      >
                        Save
                      </button>
                    </Form>
                  )}
                </Formik>
              </div>
            </CCollapse>
          </div>
          )
        }
       
      </Fragment>
    </>
  );
};

export default CompanyInformation;
